import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldAlert } from "lucide-react";

export function GateCard({ gate, secondaryGate, title = "Karmic gate" }) {
  if (!gate) return null;
  return (
    <Card className="bg-white/90 shadow-card" data-testid="journey-gate-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <ShieldAlert className="w-4 h-4 text-amber-700" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <p className="font-medium">{gate.name}</p>
        {gate.reason && <p className="text-xs text-muted-foreground">{gate.reason}</p>}
        {secondaryGate && (
          <p className="text-xs text-muted-foreground">
            Secondary: <span className="font-medium">{secondaryGate.name}</span>
          </p>
        )}
      </CardContent>
    </Card>
  );
}
